import "./fonts/fonts.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "photoswipe/dist/photoswipe.css";
import "./general.scss";

import React from "react";
import ReactDOM from "react-dom/client";

import { AllProviders } from "./AllProviders";
import { App } from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AllProviders>
    <App />
  </AllProviders>
);
